import { Link } from "react-scroll";
import { useAuth } from "../../Context/AuthContext";

function NavItems({ isMobile, page = "landingPage" }) {
  const { auth, setAuth } = useAuth();
  const baseClasses = "cursor-pointer font-bold transition-all duration-300 hover:bg-gradient-to-r from-indigo-600 to-indigo-300 hover:bg-clip-text hover:text-transparent font-poppins";

  // Different styles based on whether this is in the mobile sidebar or desktop navbar
  const desktopClasses = "text-base lg:text-lg font-medium px-3 py-1";
  const mobileClasses = "text-xl font-medium py-4 ";

  const navItemClasses = `${baseClasses} ${isMobile ? mobileClasses : desktopClasses}`;

  return (
    <>
      {page === 'landingPage' ? (
        <>
          <Link
            className={navItemClasses}
            to="home"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            activeClass="active"
          >
            Home
          </Link>
          <Link
            className={navItemClasses}
            to="features"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            activeClass="active"
          >
            Features
          </Link>
          <Link
            className={navItemClasses}
            to="howItWorks"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            activeClass="active"
          >
            How it Works
          </Link>
          <Link
            className={navItemClasses}
            to="bmc"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            activeClass="active"
          >
            BMC
          </Link>
          {auth.role === 'superAdmin' && (
            <a className={navItemClasses} href={'/admin'}>
              Admin
            </a>
          )}
        </>
      ) : (
        <>
          <a className={navItemClasses} href={'/'}>
            Home
          </a>
        </>
      )}
    </>
  );
}

export default NavItems